import { render, staticRenderFns } from "./atkmtrx_3part.vue?vue&type=template&id=3e2270e4&scoped=true&"
import script from "./atkmtrx_3part.vue?vue&type=script&lang=js&"
export * from "./atkmtrx_3part.vue?vue&type=script&lang=js&"
import style0 from "./atkmtrx_3part.vue?vue&type=style&index=0&id=3e2270e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2270e4",
  null
  
)

export default component.exports